<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="formgrid grid">
        <div class="field col-12 md:col-6">
          <label>Kode</label>
          <InputText v-model="form.kode_obat" class="w-full" disabled />
        </div>
        <div class="field col-12 md:col-6">
          <label>Obat</label>
          <InputText v-model="form.nama_obat" class="w-full" disabled />
        </div>
        <div class="field col-12 md:col-6">
          <label>Batch No</label>
          <InputText v-model="form.batch_no" class="w-full" disabled />
        </div>
        <div class="field col-12 md:col-6">
          <label>Tgl Expired</label>
          <InputText v-model="form.expired_at" class="w-full" disabled />
        </div>
        <div class="field col-12 md:col-6">
          <label>Stock Akhir</label>
          <InputText v-model="form.stock_akhir" class="w-full text-right" disabled />
        </div>
        <div class="field col-12 md:col-6">
          <label
            :class="{
              'p-error': v$.form.stock_opname.$invalid && submitted,
            }"
            >Stok Opname</label
          >
          <InputNumber
            v-model="form.stock_opname"
            :class="`w-full ${v$.form.stock_opname.$invalid && submitted ? 'p-invalid' : ''}`"
            input-class="text-right"
            autofocus
            @input="updateQty"
            @keyup.enter="handleSubmit(!v$.$invalid)"
          />
          <small
            v-if="
              (v$.form.stock_opname.$invalid && submitted) ||
              v$.form.stock_opname.$pending.$response
            "
            class="p-error"
            >{{ v$.form.stock_opname.required.$message }}</small
          >
        </div>
        <div class="field col-12">
          <label>Keterangan</label>
          <InputText v-model="form.keterangan" class="w-full" />
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          label="Tutup"
          icon="pi pi-times"
          @click="$emit('close')"
          class="p-button-text mr-2"
        />
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      submitted: false,
      form: this.item,
    }
  },
  methods: {
    updateQty(so) {
      this.form.selisih = parseInt(so.value) - this.form.stock_akhir
      this.form.total = this.form.selisih * this.form.harga;
    },
    handleSubmit(isFormValid) {
      this.submitted = true

      if (!isFormValid) {
        return
      }

      const form = Object.assign({}, this.form)

      this.$emit('save', form)
    },
  },
  validations() {
    return {
      form: {
        stock_opname: {
          required: helpers.withMessage('Jumlah harus diisi.', required),
        },
      },
    }
  },
}
</script>
